var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { TableViewer } from "../Layout/TableViewer";
import Library from "./Library";
import LibraryLayout from "./LibraryLayout";
import DocumentsList from "./components/DocumentsList";
import { requestState } from "./helpers/requestState";
import { withRouter } from "../componentWrappers";
import { trackPage } from "../App/GoogleAnalytics";

class LibraryTableComponent extends Library {
  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources, { calculateTableColumns: true });
  }

  render() {
    trackPage();
    return /*#__PURE__*/(
      _jsx(LibraryLayout, { sidePanelMode: "unpinned-mode" }, void 0, /*#__PURE__*/
      _jsx(DocumentsList, {
        storeKey: "library",
        CollectionViewer: TableViewer,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        scrollCount: this.state.scrollCount,
        tableViewMode: true }
      )
      ));

  }
}

const SSRLibraryComponent = withRouter(LibraryTableComponent);

const LibraryTable = Object.assign(SSRLibraryComponent, {
  requestState: LibraryTableComponent.requestState
});

export { LibraryTableComponent };
export { LibraryTable };